module.exports = __webpack_public_path__ + "static/img/rcontenttitle.bc051630.png";